// Retrato (cartoon Pixar 3D) por colaborador. Los .webp los recorta tools/crop-team.py del póster
// del equipo y viven en src/assets/equipo/<slug>.webp, así que Vite los hashea y el motor los sirve
// cacheados sin riesgo de quedar pegados (a diferencia de public/, que va immutable sin hash).
//
// Cargados con import.meta.glob({eager}) para no mantener 18 imports a mano: añadir un retrato =
// soltar el .webp. avatarFor() devuelve null si falta, y quien lo pinte cae al círculo con la
// inicial — un retrato ausente nunca debe romper el panel.
// UN RETRATO PRESTADO. `kdp-audit.webp` (Auditor de fichas KDP) es `auditor.webp` (Auditor de
// autoría) reflejado en el eje vertical: era el único colaborador sin cara y salía con iniciales
// en medio de diecisiete retratos. Se dice aquí porque si no, dentro de seis meses, el parecido
// entre los dos auditores parece un fallo de recorte en vez de una decisión.
const files = import.meta.glob("./assets/equipo/*.webp", { eager: true, query: "?url", import: "default" });

const BY_SLUG: Record<string, string> = {};
for (const [path, url] of Object.entries(files)) {
  const slug = path.split("/").pop()!.replace(".webp", "");
  BY_SLUG[slug] = url as string;
}

/** URL del retrato del colaborador `id`, o null si no hay (→ usar la inicial como fallback). */
export function avatarFor(id: string | undefined): string | null {
  return (id && BY_SLUG[id]) || null;
}
